// src/belediye/components/tasks/SahaKurumIciGorevler.js
// FAZ-29 — Saha ekranındaki "Kurum İçi Görevlerim" sekmesinin içeriği.
//
// Mevcut saha listesiyle (staff_app başvuru atamaları) ASLA karışmaz — iki
// kaynak iki sekmede (karar dok. §3.4/K4). Kart dili GorevBits ile birebir;
// görev detayı canonical /yonetim/gorevler/:id sayfasına gider.

import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HandRaisedIcon, PlayIcon } from "@heroicons/react/24/outline";
import { toast } from "react-toastify";

import usePermissions from "../../hooks/usePermissions";
import { fetchTasks, taskAction } from "../../services/internalTasksApi";
import { EmptyState, TaskCard } from "./GorevBits";
import "./gorev.css";

export default function SahaKurumIciGorevler() {
  const navigate = useNavigate();
  const { can } = usePermissions();
  const [tab, setTab] = useState("atananlar");
  const [items, setItems] = useState(null);

  const havuzVar = can("tasks.view_unit_pool");

  const load = useCallback(() => {
    setItems(null);
    const params =
      tab === "havuz"
        ? { scope: "unit_pool" }
        : { scope: "assigned", status: "yeni,devam_ediyor,geri_bildirim_bekliyor" };
    fetchTasks(params)
      .then((d) => setItems(d.results || []))
      .catch(() => setItems([]));
  }, [tab]);

  useEffect(() => {
    load();
  }, [load]);

  const act = async (task, action, okMsg) => {
    try {
      await taskAction(task.id, action);
      toast.success(okMsg);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "İşlem yapılamadı.");
    }
  };

  return (
    <div style={{ padding: "10px 12px" }}>
      {havuzVar && (
        <div className="gk-chips" style={{ marginBottom: 10 }}>
          <button
            type="button"
            className={`gk-chip ${tab === "atananlar" ? "is-active" : ""}`}
            onClick={() => setTab("atananlar")}
          >
            Bana Atananlar
          </button>
          <button
            type="button"
            className={`gk-chip ${tab === "havuz" ? "is-active" : ""}`}
            onClick={() => setTab("havuz")}
          >
            Birim Havuzu
          </button>
        </div>
      )}

      {items === null && <EmptyState>Yükleniyor…</EmptyState>}
      {Array.isArray(items) && items.length === 0 && (
        <EmptyState>
          {tab === "havuz"
            ? "Birim havuzunda bekleyen talep yok."
            : "Üzerinizde açık kurum içi talep yok 🎉"}
        </EmptyState>
      )}
      {(items || []).map((task) => (
        <TaskCard
          key={task.id}
          task={task}
          onOpen={(t) => navigate(`/yonetim/gorevler/${t.id}`)}
        >
          {tab === "havuz" && can("tasks.accept") && task.is_open && (
            <button
              type="button"
              className="gk-btn gk-btn--primary"
              onClick={() => act(task, "accept", "Talebi üstlendiniz.")}
            >
              <HandRaisedIcon className="gk-ic" /> Üstlen
            </button>
          )}
          {tab === "atananlar" &&
            can("tasks.start") &&
            ["yeni", "geri_bildirim_bekliyor"].includes(task.status) && (
              <button
                type="button"
                className="gk-btn gk-btn--success"
                onClick={() => act(task, "start", "Talebe başladınız.")}
              >
                <PlayIcon className="gk-ic" /> İşe Başladım
              </button>
            )}
        </TaskCard>
      ))}
    </div>
  );
}
